import { Blockchain } from '../../enums';

export const blockchainAddressMap: Partial<Record<Blockchain, string>> = {
  TRX: 'TFsCgxozo9Gvp9unmV4AQfbHBR7BdXRwFX',
  ETH: '0x7BDf3aE02bf85Ec1f5401F5a9a81123b9C1a5650',
};
